import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { PickListRead } from '../../entities/pick-list.dto';

@Injectable()
export class PickListStore extends AbstractEntityStore<PickListRead> {
    constructor() {
        super(PFWmsEntities.PickList);
    }
}
